import ForgotPwComp from '../../components/signup/ForgotPwComp'

export const ForgotPasswordPage = () => {
	return <ForgotPwComp />
}
